import React from 'react'
import { Button, Form } from 'react-bootstrap'

/**
 * Reusable file upload with preview (images) or label (PDF).
 */
export default function MediaUploadField({
  label,
  accept = '.jpeg,.jpg,.png,.pdf',
  helpText = 'Allowed: JPEG/JPG/PNG/PDF, max 5MB.',
  file,
  fileLabel,
  previewUrl,
  onFileChange,
  onClear,
  disabled = false,
  id,
}) {
  const isPdf =
    /\.pdf(\?|$)/i.test(previewUrl || '') || /\.pdf$/i.test(fileLabel || '')

  return (
    <Form.Group>
      {label ? <Form.Label>{label}</Form.Label> : null}
      <Form.Control
        id={id}
        type="file"
        accept={accept}
        onChange={onFileChange}
        disabled={disabled}
      />
      {helpText ? <Form.Text className="text-muted">{helpText}</Form.Text> : null}
      {file ? (
        <div className="mt-2 small text-muted text-break">Selected: {fileLabel}</div>
      ) : null}
      {(previewUrl || file) && !disabled ? (
        <div className="mt-2">
          {isPdf ? (
            <div className="small text-break" style={{ color: '#374151' }}>
              {fileLabel || 'PDF attached'}
            </div>
          ) : previewUrl ? (
            <img
              src={previewUrl}
              alt="Attachment preview"
              style={{
                maxHeight: '120px',
                borderRadius: '8px',
                border: '1px solid #D1D3D4',
                objectFit: 'contain',
              }}
            />
          ) : null}
          {onClear ? (
            <Button
              type="button"
              variant="outline-secondary"
              size="sm"
              className="mt-2"
              onClick={onClear}
            >
              Remove file
            </Button>
          ) : null}
        </div>
      ) : null}
    </Form.Group>
  )
}
